import styled from "../../styled-components.mjs";
import { cssSpacing } from "../../styles/layout-theme.mjs";
export var IconSelected = styled.div.withConfig({
  displayName: "IconSelected",
  componentId: "sc-1a4w7w-0"
})(["position:absolute;display:inline-flex;inset-inline-end:", ";"], cssSpacing('tighter', '12px'));